<template>
  <div class="view box grow">
    <page-headers :header="customHostname" :breadcrumbs="breadcrumbs" :is-border="true" class="box">
      <i slot="title-left-icon" class="mr-5 fab" :class="`fa-${agentOSType}`"></i>
      <div slot="title-links">
        <el-tag v-if="warning" size="medium" type="danger" class="warning">
          <router-link :to="{ name: 'detections', query: { hostName: customHostname, date_range: 'PAST_1_MONTH' } }"
            ><span class="display-inline-block">{{ warning }}</span>
          </router-link>
        </el-tag>
      </div>
      <!-- <div slot="actions" class="float-right">
        <date-range-dropdown
          :class="{ 'display-none': activeTab !== 'host-insights' }"
          :date-range-options="dateRangeOptions"
          :store-pref-constant="daterangeUserPrefConstant"
          :date-range-val="hostInsightsDateRangeUserSetting"
        ></date-range-dropdown>
      </div> -->
    </page-headers>
    <el-tabs v-model="activeTab" @tab-click="goto">
      <el-tab-pane v-if="insightsEnabled" label="Insights" name="host-insights"></el-tab-pane>
      <el-tab-pane label="Details" name="host-details"></el-tab-pane>
      <el-tab-pane
        v-if="agent && agent.containers.length > 0"
        label="Containers"
        name="container-details"
      ></el-tab-pane>
    </el-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import DateRangeDropdown from '@/components/dropdown/DateRangeDropdown.vue'

import { AgentStateEnum } from '@/constants/host-status.constants'
import { INSIGHTS_DATE_RANGE_CHOICES } from '@/constants/datetime.constants'
import { HOST_INSIGHTS_DATE_RANGE_PREFERENCE } from '@/store/modules/user_pref/user-pref.type'
import { AGENT_DETAILS_REQ } from '@/store/modules/agents/agents.type'

export default {
  name: 'HostDashboard',
  data () {
    return {
      daterangeUserPrefConstant: HOST_INSIGHTS_DATE_RANGE_PREFERENCE,
      dateRangeOptions: INSIGHTS_DATE_RANGE_CHOICES,
      breadcrumbs: [{ title: 'Dashboard' }, { title: 'Hosts', to: '/assets/hosts' }],
      activeTab: 'insights',
      agendId: '',
      customHostname: '',
      agent: null,
      warning: false
    }
  },
  created () {
    this.agentId = this.$route.params.agentId
    this.loadTabDetails()
  },
  beforeMount () {
    let namedRoute = this.$route.name
    if (namedRoute === 'host-insights' && !this.insightsEnabled) {
      namedRoute = 'host-details'
    } else if (namedRoute === 'dashboard-hosts') {
      namedRoute = 'host-insights'
    }
    this.$router.push({
      name: namedRoute,
      query: this.$route.query,
      params: this.$route.params
    })
    this.activeTab = namedRoute
  },
  methods: {
    goto ({ name }) {
      this.$router.push({
        name: name,
        query: this.$route.query,
        params: this.$route.params
      })
    },
    loadTabDetails () {
      this.$store.dispatch(AGENT_DETAILS_REQ, this.agentId).then(
        agent => {
          this.agent = agent
          this.agent.publicIPs = this.agent.publicIPs.sort()
          this.agent.privateIPs = this.agent.privateIPs.sort()
          this.customHostname = this.agent.customHostname
          if (this.breadcrumbs.length === 2) {
            this.breadcrumbs.push({ title: this.customHostname })
          }
          if (this.agent.agentStatus !== AgentStateEnum.OFFLINE && this.agent.aggregatedRiskScore > 0) {
            this.warning = 'at risk'
          }
        },
        errMsg => {
          const h = this.$createElement
          this.$msgbox({
            title: 'Details Error',
            message: h('p', null, 'There was an error loading the agent you requested.'),
            showCancelButton: false,
            confirmButtonText: 'Ok',
            beforeClose: (action, instance, done) => {
              window.location.href = '/#/hosts'
            }
          })
        }
      )
    }
  },
  computed: {
    ...mapGetters(['insightsEnabled', 'agentDetailsReqStatus', 'hostInsightsDateRangeUserSetting']),
    agentOSType () {
      if (this.agent) {
        return this.agent.system.os.toLowerCase()
      }
      return ''
    }
  },
  watch: {
    agentDetailsReqStatus: {
      handler: (newStatus, oldStatus) => {
        if (newStatus === 'error') {
          console.log('error')
        }
      }
    }
  },
  components: {
    PageHeaders,
    DateRangeDropdown
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.warning {
  text-transform: uppercase;
  vertical-align: bottom;

  a {
    color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/HostDashboard.vue